export const URL = {
    providercore_url: (window.location.hostname === 'ins.medibuddy.in' || window.location.hostname === 'labwise.medibuddy.in' || window.location.hostname === 'provider-central.medibuddy.in') ? "https://providercore.medibuddy.in/" : "https://providernode.mbstg.in/",
    api_corecheck: 'https://ch-api-procheck.medibuddy.in/',
    dev_url: "https://providercore.medibuddy.in/",
    s3_upload_image_url: "https://providercore.medibuddy.in/provider/Uploadfile",
    mb_wapi: "https://www.medibuddy.in/WAPI/",
    api_plus: "https://api-plus.medibuddy.in/",
    ins_medibuddy:  "https://ins-integration.medibuddy.in/",
    procheck: "https://ch-api-procheck.medibuddy.in/",
    cleverTap: "https://api.clevertap.com/1/upload",
    plus_api_prod: "https://plus-api-prod.medibuddy.in/",
    core_provider_master: "https://ch-coreprovidermaster.medibuddy.in/",
    integration_url : "https://integration-plus-plus.medibuddy.in/PlusAPI/",
    fuser_url : "https://fuser.medibuddy.in/",
}

export const USER = {
    access_token: localStorage.getItem("access_token") ? localStorage.getItem("access_token") : '',
    user: localStorage.getItem('user_details') ? JSON.parse(localStorage.getItem("user_details")) : [],
    roleName: localStorage.getItem('roleName') ? localStorage.getItem("roleName") : '',
}

export const allowedUsers = [
    "vinayak.milind.klm",
    "syed.mahboob.ins",
    "prateek.divakar.ins",
    "prachi.singh.ins",
    "rahul.b.ins",
    "anthony.jeevan.ins",
    "neeru.sharma.ins"
  ];

export const InsurerRoleIds = [9211, 9207, 9214, 9219];

export const Roles = {
    dcadmin: 5432,
    dcoperations: 5433,
    insureradmin: 9207,
    insureragent: 9211,
    insurerbranch: 9214,
    mareport: 9217,
    insurercallCentre: 9219,
}

export const STATUS_CODE_MAP = {
    "New Appointment Request": 22,
    "Confirmed by Medical Center": 23,
    "Confirmed by Ops": 24,
    "Cancelled by Medical Center": 26,
    "Rescheduled by Medical Center": 29,
    "Rescheduled by Ops": 30,
    "Rescheduled by User": 31,
    "Attended": 32,
    "Information Awaited": 33,
    "Info submitted": 37,
    "Not Attended": 39,
    "Customer awaited at DC": 40,
    "Cancelled": 42,
    "QCApproved": 48,
    "Partially Attended": 116,
    "NotAttended by Others": 118,
    "Cancelled by Insurer": 119,
    "Closed by Insurer": 120,
    "TU Completed": 121,
    "TU Scheduled": 122,
    "TU Information Awaited": 123,
    "Fit with recommendation": 126,
    "Fitness on Hold": 127,
    "Temporary unfit": 128,
    "System Confirmed": 129,
    "Non Workable": 130,
    "Digitization Pending": 134,
    "ReportProcessPending": 140,
    "Rejected": 146
}

export const ProvidersAffiliateOrders = [419652, 407516]
export const SLA_FILTERS = {
    "New Appointments": "NewAppointments",
    "Confirmed Appointments": "AttendanceConfirmation",
    "Documents Pending": "ReportUploaded"
}

export const CLEVER_TAP_EVENTS = {
    loginVisited: "Labwise Landing on Home Page",
    // loginAttempted:"Labwise Logging into portal",
    loginSuccess: "Labwise Login Sucess",
    loginFailed: "Labwise Login Failed",

    newApptVisited: "Labwise New Appointments Tab",
    // confirmBtnClick:"Labwise Clicking on Individual Confirm Button",
    // confirmPopupShown:"Labwise Individual Confirm popup shown",
    // confirmPopupBtnClick:"Labwise Individual Confirm popup click",
    confirmedApptSuccess: "Labwise Individual Confirm success",
    confirmedApptFailed: "Labwise Individual Confirm Failure",

    rejectApptSuccess: "Labwise Individual Reject success",

    bulkConfirmBtnClick: "Labwise Bulk Confirm Appointment clicked",
    // bulkConfirmPopupShown:"Labwise Bulk Appointment Confirm Popup Shown",
    // bulkConfirmPopupBtnClick:"Labwise Bulk Appointment Final Confirm clicked",
    bulkConfirmedApptSuccess: "Labwise Bulk Appointment Confirm Success",
    // bulkConfirmedApptFailed:"Labwise Bulk Appointment Confirm Failure",

    confirmedApptVisited: "Labwise Confirmed Appointments tab clicked",
    // markAttendedBtnClick:"Labwise Mark Attendance button clicked",
    // markAttendedPopupShown:"Labwise Mark Attended Popup shown",
    markAttendedPopupBtnClick: "Labwise MarkAttended on popup clicked",
    markAttendedSuccess: "Labwise Mark Attendance function success",
    // markAttendedFailed:"Labwise Mark Attendance function failure",

    // markNotAttendedBtnClick:"Labwise Mark Not Attendance button clicked",
    // markNotAttendedPopupShown:"Labwise Mark Not Attendance popup shown",
    // markNotAttendedPopupBtnClick:"Labwise Mark Not Attendance popup clicked",
    // markNotAttendedSuccess:"Labwise Not Mark Attendance function success",
    // markNotAttendedFailed:"Labwise Not Mark Attendance function failure",

    // bulkMarkAttendedBtnClick:"Labwise Bulk Attendance Click",
    // bulkMarkAttendedPopupShown:"Labwise Bulk Attendance Popup Shown",
    // bulkMarkAttendedPopupBtnClick:"Labwise Bulk Attendance Final Click",
    bulkMarkAttendedSuccess: "Labwise Mark Bulk Attendance Success",
    // bulkMarkAttendedFailed:"Labwise Bulk Attendance Failure",

    // attachDocIconClick:"Labwise Attach Document Click",
    // attachDocsPopupShown:"Labwise Submit Document Popup Shown",
    // attachReportsClick:"Labwise Attach Lab Reports Clicked",
    // uploadReportFailed:"Labwise Attach Lab Reports Failed",
    // attachBillsClick:"Labwise Attach Bills Clicked",
    // uploadBillsFailed:"Labwise Attach Bills failed",
    attachDocsFinalClick: "Labwise Documents Final Submit Click",
}

export const StatusMapping = [
    {
        statusId: 22,
        status: "New Appointment Request",
        StatusNew: "Appointment Created"
    },
    {
        statusId: 23,
        status: "Confirmed by Medical Center",
        StatusNew: "Appointment Confirmed"
    },
    {
        statusId: 24,
        status: "Confirmed by Ops",
        StatusNew: "Appointment Confirmed"
    },
    {
        statusId: 26,
        status: "Cancelled by Medical Center",
        StatusNew: "Cancelled"
    },
    {
        statusId: 27,
        status: "Cancelled by Ops",
        StatusNew: "Cancelled"
    },
    {
        statusId: 29,
        status: "Rescheduled by Medical Center",
        StatusNew: "Appointment Created"
    },
    {
        statusId: 30,
        status: "Rescheduled by Ops",
        StatusNew: "Appointment Created"
    },
    {
        statusId: 32,
        status: "Attended",
        StatusNew: "Attended"
    },
    {
        statusId: 33,
        status: "Information Awaited",
        StatusNew: "Report Awaited"
    },
    {
        statusId: 37,
        status: "Info submitted",
        StatusNew: "Report Uploaded"
    },
    {
        statusId: 39,
        status: "Not Attended",
        StatusNew: "Not Attended"
    },
    {
        statusId: 40,
        status: "Customer Awaited",
        StatusNew: "Appointment Confirmed"
    },
    {
        statusId: 42,
        status: "MACancel",
        StatusNew: "Cancelled"
    },
    {
        statusId: 48,
        status: "QCApproved",
        StatusNew: "Reports Verified"
    },
    {
        statusId: 116,
        status: "Partially Attended",
        StatusNew: "Partially Attended"
    }
    ,
    {
        statusId: 117,
        status: "Rescheduled by Others",
        StatusNew: "Appointment Created"
    }
    ,
    {
        statusId: 118,
        status: "NotAttended by Others",
        StatusNew: "Not Attended"
    }
    ,
    {
        statusId: 119,
        status: "CancelledByInsurer",

        StatusNew: "Cancelled By Insurer"
    }
    ,
    {
        statusId: 120,
        status: "ClosedByInsurer",
        StatusNew: "Cancelled By Insurer"
    }
    ,
    {
        statusId: 130,
        status: "Not Workable",
        StatusNew: "Cancelled By Insurer"
    }
    ,
    {
        statusId: 129,
        status: "System Confirmation",
        StatusNew: "Appointment Confirmed"
    }
    ,
    {
        statusId: 134,
        status: "Digitization Pending",
        StatusNew: "Reports Under Verification"
    }
    ,
    {
        statusId: -1,
        status: "WIP",
        StatusNew: "New Request"
    }
    ,
    {
        statusId: 0,
        status: "WIP-ClosedByInsurer",
        StatusNew: "New Request"
    },
    {
        statusId: 131,
        status: "Workable",
        StatusNew: "New Request"
    },
    {
        statusId: 138,
        status: "HomeSampleCollectionAwaited",
        StatusNew: "Appointment Created"
    },
    {
        statusId: 139,
        status: "HomeSampleCollected",
        StatusNew: "Appointment Created"
    },
    {
        statusId: 146,
        status: "Rejected By Provider",
        StatusNew: "Appointment Created"
    },
    {
        statusId: 147,
        status: "Routed To Provider",
        StatusNew: "Appointment Created"
    }]

export const MBContract = {
    PrePolicy: 4625,
    MediAssistDC: 5290,
    Retail_Mediassist: 5291,
    AnnualHealthCheck: 9716,
    PreEmployment: 9717,
    MAYA_Seniors: 9718,
    ChildVaccination: 9767,
    ESALES: 9782,
    CONSUMABLES: 13665,
    Maternity: 9786,
    OPD_Consultation: 10124,
    SeniorCare: 10129,
    DrugTest: 10136,
    OPD_Radiology: 10302,
    OPD_Lab_Investigation: 10303,
    HomeHealthCare: 10304,
    PharmaContract: 10307,
    OnsiteHealthCheckUp: 10384,
    MP_HEALTHCHECK: 10386,
    MP_INVESTIGATION: 10389,
    MP_PHARMACY: 10390,
    MP_CONSULTATION: 10401,
    SecondOpinion: 10595,
    MP_SECONDOPINION: 10845,
    MP_ONLINECONSULTATION: 10846,
    MP_HOMEHEALTHCARE: 10847,
    MP_GENOME: 10861,
    My_Dental_Plan: 10949,
    Overseas: 12365,
    YourDost: 12492,
    MP_DENTAL: 12553,
    TeleUnderwriting: 12719,
    OccupationalHealthCenter: 13233,
    DietAndNutrition: 14008,
    Wellness_HRA: 14075
}

export const ABSLI_ENTITYIDS_INSURANCE = [1005309, 1163244, 11174793]

export const KOTAK_ERID = ['61662', '455026']